import ControleEdicaoService from "@/services/ControleEdicaoService";

export const controleEdicao = {
  namespaced: true,
  state: {
    controleEdicao: {},
  },
  actions: {
    getControleEdicao({ commit }, payload) {
      return ControleEdicaoService.GetControleEdicao(payload).then(
        (controleEdicao) => {
          return Promise.resolve(controleEdicao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postControleEdicao({ commit }, payload) {
      return ControleEdicaoService.PostControleEdicao(payload).then(
        (controleEdicao) => {
          return Promise.resolve(controleEdicao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putControleEdicao({ commit }, payload) {
      return ControleEdicaoService.PutControleEdicao(payload).then(
        (controleEdicao) => {
          return Promise.resolve(controleEdicao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteControleEdicao({ commit }, payload) {
      return ControleEdicaoService.DeleteControleEdicao(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getControleEdicaoOData({ commit }, payload) {
      return ControleEdicaoService.GetControleEdicaoOData(payload).then(
        (controleEdicao) => {
          return Promise.resolve(controleEdicao);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    deleteControleEdicaoIdEdicao({ commit }, payload) {
      return ControleEdicaoService.DeleteControleEdicaoIdEdicao(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default controleEdicao;
